<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-22 09:25:30
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:04:59
 * @name: 添加或编辑产品
 * @Description: 添加或编辑产品
 * @FilePath: \preSaleNafterSaleBackstage\src\components\waresGoodsManage\dialog\addNedit-product.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <addNeditDialog ref="addNeditDialog" :title="title[titleIndex]">
    <template v-slot:form>
      <div class="line">
        <font class="label"><i class="warn">*</i>产品型号:</font>
        <el-select
          class="input"
          v-model="form.category_id"
          placeholder="请选择产品型号"
        >
          <el-option
            v-for="item of modelGoods.options_model"
            :key="item.id"
            :label="item.category_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="line">
        <font class="label"><i class="warn">*</i>产品名称:</font>
        <el-input
          class="input"
          v-model="form.goods_name"
          placeholder="请输入产品名称"
        >
        </el-input>
      </div>
      <div class="line">
        <font class="label"><i class="warn">*</i>颜色:</font>
        <el-select
          class="input"
          v-model="form.color_id"
          placeholder="请选择颜色"
        >
          <el-option
            v-for="item of waresGoods.options_color"
            :key="item.id"
            :label="item.color"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="line">
        <font class="label"><i class="warn">*</i>价格:</font>
        <el-input
          class="input"
          v-model="form.price"
          placeholder="请输入产品价格"
        >
        </el-input>
      </div>
      <div class="line">
        <font class="label"><i class="warn">*</i>库存:</font>
        <el-input
          class="input"
          v-model="form.stock"
          placeholder="请输入产品库存"
        >
        </el-input>
      </div>
      <div class="line">
        <font class="label"><i class="warn">*</i>产品图片:</font>
        <!-- 选择图片input -->
        <input
          type="file"
          accept="image/*"
          id="filed"
          hidden
          @change="filePreview"
        />
        <div class="selectImage" @click="selectImg()">
          <i class="el-icon-folder-add" v-if="!form.file_id"></i>
          <img :src="image" v-else />
        </div>
      </div>
      <div class="line">
        <font class="label">状态:</font>
        <el-radio-group v-model="form.status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </div>
      <div class="settingbox">
        <font class="label">产品售价（至少输入一项）</font>
        <div class="setting">
          <div
            class="setting-line"
            v-for="(item, index) of form.goods_level"
            :key="index"
          >
            <div class="left">
              <i class="warn">*</i>
              <el-select
                size="mini"
                style="width: 100px; margin-right: 10px"
                v-model="item.level"
              >
                <el-option
                  :label="'级别' + itemY"
                  :value="itemY"
                  :key="indexY"
                  v-for="(itemY, indexY) of levels"
                  :disabled="!canUseLevels.includes(itemY)"
                ></el-option>
              </el-select>
              <font class="label2">价格:</font>
              <el-input
                class="price"
                size="mini"
                placeholder="请输入类目价格"
                v-model="item.price"
              ></el-input>
            </div>
            <el-button size="mini" type="danger" @click="del(index)"
              >删除</el-button
            >
          </div>
          <el-button class="add" size="mini" type="primary" @click="add"
            >添加</el-button
          >
        </div>
      </div>
    </template>
    <template v-slot:btnGroup>
      <el-button class="submit" type="primary" @click="submit">确认</el-button>
    </template>
  </addNeditDialog>
</template>
<script>
import addNeditDialog from "./addNeditDialog.vue";
import { uploadImage } from "@/api/index/index.api.js";
import { confirmation, debounceation } from "@/utils/decorator";
export default {
  name: "addNeditProduct",
  components: {
    addNeditDialog,
  },
  props: {
    modelGoods: {
      type: Object,
    },
    waresGoods: {
      type: Object,
    },
  },
  data() {
    return {
      title: ["添加产品", "编辑产品"], //标题候选数组
      titleIndex: 0, //选用的标题下标
      id: "", //商品id,添加时为空
      form: {
        //表单数据
        category_id: "", //型号id
        goods_name: "", //商品名称
        color_id: "", //颜色id
        price: "", //商品价格(默认价格)
        stock: "", //商品库存
        file_id: "", //图片id
        status: 1, //显示状态 1显示 0不显示
        goods_level: [{ level: "", price: "" }], //级别-价格数组
      },
      image: "", //图片地址
      levels: [1, 2, 3, 4, 5, 6], //可选级别数组
    };
  },
  computed: {
    // 验证型号是否已选
    category_id_match() {
      return !this.form.category_id;
    },
    // 验证商品名称是否已填
    goods_name_match() {
      return !this.form.goods_name;
    },
    // 验证颜色是否已选
    color_id_match() {
      return !this.form.color_id;
    },
    // 验证价格是否已填且正确
    price_match() {
      return (
        !this.form.price ||
        isNaN(this.form.price) ||
        Number(this.form.price) < 0
      );
    },
    // 验证库存是否已填且正确
    stock_match() {
      return (
        !this.form.stock ||
        isNaN(this.form.stock) ||
        Number(this.form.stock) < 0
      );
    },
    // 验证图片是否已上传
    file_id_match() {
      return !this.form.file_id;
    },
    // 可选级别数组(所有级别过滤掉已选级别)
    canUseLevels() {
      return this.levels.filter(
        (x) =>
          this.form.goods_level.findIndex((y) => Number(y.level) === x) === -1
      );
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 验证输入值
     * @param {Object} e 验证项
     * @return {Boolean} 验证是否通过
     */
    goods_level_match(e) {
      return !e.level || !e.price || isNaN(e.price) || Number(e.price) < 0;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗,编辑状态赋初始值
     * @param {Object | undefind} form 产品原数据 | 未传
     */
    open(form) {
      let {
        id,
        category_id,
        goods_name,
        color_id,
        price,
        stock,
        file_id,
        image,
        status,
        goods_level,
      } = form || {
        id: "",
        category_id: "",
        goods_name: "",
        color_id: "",
        price: "",
        stock: "",
        file_id: "",
        image,
        status: 1,
        goods_level: [{ level: "", price: "" }],
      }; //传了值赋值,未传值赋默认值
      this.id = id; //赋值id
      this.image = image;
      this.titleIndex = id ? 1 : 0; //判断是否有id,有即编辑,否则为添加
      this.form = {
        category_id: Number(category_id) || "",
        goods_name,
        color_id: Number(color_id) || "",
        price: Number(price) || "",
        stock: String(stock) || "",
        file_id,
        status,
        goods_level,
      };
      this.$refs.addNeditDialog.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗
     */
    @debounceation(300)
    cancel() {
      this.$refs.addNeditDialog.close();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击提交,判断是否有id,有即编辑,否则为添加
     */
    @debounceation(300)
    submit() {
      this.form.goods_level = this.form.goods_level.sort((x, y) => {
        return x.level - y.level;
      });
      this.id && this.$emit("edit", { goods_id: this.id, ...this.form });
      this.id || this.$emit("add", this.form);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 产品售价添加一行
     */
    @debounceation(300)
    add() {
      if (this.form.goods_level.length === 6) {
        this.$message.error("级别最多6级");
        return;
      }
      this.form.goods_level.push({ price: "" });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 产品售价删除一行
     * @param {Number} index 数组下标
     */
    @confirmation("确认删除该级别?")
    del(index) {
      if (this.form.goods_level.length === 1) {
        this.$message.error("至少输入一项!");
        return;
      }
      this.form.goods_level.splice(index, 1);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击产品图片框,触发input[type=file]的上传事件，调用filePreview函数
     */
    @debounceation(300)
    selectImg() {
      document.getElementById("filed").click();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 上传图片
     * @param {Object} e input[type=file]回调
     */
    filePreview(e) {
      let files = e.target.files[0];
      if (files) {
        let formData = new FormData();
        formData.append("myFile", files);
        uploadImage(formData).then((res) => {
          this.form.file_id = res.data.file_id;
          this.image = res.data.file_url_path;
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.line {
  margin-bottom: 20px;
  width: 100%;
  height: inherit;
  @extend .extend-flex-start;
  .label {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    width: 100px;
    text-align: left;
    flex-shrink: 0;
    position: relative;
    .warn {
      position: absolute;
      left: -10px;
      color: red;
    }
  }
  .input {
    flex: 1;
  }
  .selectImage {
    align-self: flex-start;
    width: 100px;
    height: 100px;
    border: 1px dashed $Vars-font-placeholder-color;
    border-radius: $Vars-border-radius-normal;
    overflow: hidden;
    @extend .extend-clickElement;
    @extend .extend-flex-center;
    i {
      font-size: 40px;
      color: $Vars-font-placeholder-color;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.settingbox {
  margin-bottom: 20px;
  width: 100%;
  @extend .extend-flex-column-center;
  .label {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    align-self: flex-start;
  }
  .setting {
    width: 80%;
    @extend .extend-flex-column-normal;
    .setting-line {
      margin-top: 30px;
      width: 100%;
      @extend .extend-flex-spacebetween;
      .left {
        @extend .extend-flex-start;
        position: relative;
        .warn {
          position: absolute;
          left: -20px;
          content: "*";
          color: red;
        }
        .level {
          font-size: $Vars-font-miniContent-size;
          color: $Vars-font-normal-color;
          font-weight: bold;
          flex-shrink: 0;
          margin-right: 10px;
        }
        .label2 {
          font-size: $Vars-font-miniContent-size;
          color: $Vars-font-normal-color;
          flex-shrink: 0;
          margin-right: 10px;
        }
        .price {
          width: 200px;
        }
      }
    }
    .add {
      margin-top: 30px;
    }
  }
}
.submit {
  width: $Var-button-width-normal;
}
/deep/ input#file-upload-button {
  background: white;
}
</style>